import { Link } from "react-router-dom";
import { COMPANY } from "@/lib/site";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-ink2 text-white/80"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <Link to="/" className="flex items-center" data-testid="footer-logo">
            <img
              src={COMPANY.logo}
              alt="G&G accounting"
              className="h-14 w-auto object-contain"
              style={{ mixBlendMode: "screen" }}
            />
          </Link>
          <p className="mt-6 text-sm leading-relaxed text-white/60 max-w-xs">
            Účetní partner pro firmy a živnostníky v Brně a okolí. Osobní přístup, srozumitelná
            komunikace, čísla, kterým rozumíte.
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-magenta font-semibold mb-5">
            Navigace
          </h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="hover:text-magenta transition-colors" data-testid="footer-nav-home">Domů</Link></li>
            <li><Link to="/sluzby" className="hover:text-magenta transition-colors" data-testid="footer-nav-services">Služby</Link></li>
            <li><Link to="/o-nas" className="hover:text-magenta transition-colors" data-testid="footer-nav-about">O nás</Link></li>
            <li><Link to="/kontakt" className="hover:text-magenta transition-colors" data-testid="footer-nav-contact">Kontakt</Link></li>
            <li><Link to="/klientska-zona" className="hover:text-magenta transition-colors" data-testid="footer-nav-zone">Klientská zóna</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-magenta font-semibold mb-5">
            Kontakt
          </h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 mt-0.5 text-magenta shrink-0" />
              <a href={`mailto:${COMPANY.emailBystricka}`} className="hover:text-magenta transition-colors break-all" data-testid="footer-email">
                {COMPANY.emailBystricka}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Phone className="w-4 h-4 mt-0.5 text-magenta shrink-0" />
              <a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`} className="hover:text-magenta transition-colors" data-testid="footer-phone">
                {COMPANY.phone}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-0.5 text-magenta shrink-0" />
              <span className="text-white/70">{COMPANY.address}</span>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-magenta font-semibold mb-5">
            Právní
          </h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/zasady-zpracovani-osobnich-udaju" className="hover:text-magenta transition-colors" data-testid="footer-privacy">Zásady zpracování OÚ</Link></li>
            <li><Link to="/cookies" className="hover:text-magenta transition-colors" data-testid="footer-cookies">Cookies</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <span>© {year} {COMPANY.name} · IČO: {COMPANY.ico}</span>
        </div>
      </div>
    </footer>
  );
}
